<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="qualityControl-box">
      <div class="center-box">
        <div class="crumbs">首页 > 会议直播 > 会议直播详情</div>
        <div class="poster-box" v-if="liveDetails.id">
          <img v-if="liveDetails.detailImage" :src="liveDetails.detailImage.url" alt="">
          <div class="activity-btn-box" @click="onClickRoute" v-if="liveDetails.status != 'END'">
            预约报名
          </div>
          <div class="activity-btn-box" @click="onClickRouteTwo" v-if="liveDetails.status == 'LIVING' && liveDetails.enrollmentStatus">
            观看直播
          </div>
        </div>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import { getLiveDetail } from '@/api/home'

export default {
  name: "LiveDetail",
  components: { FooterBar, headerBar, siteNav },
  data() {
    return {
      selectedIndex: 3,
      id: '',
      liveDetails: {}
    }
  },
  methods: {
    // 按 id 查询直播管理
    async getLiveDetail() {
      await getLiveDetail({
        id: this.id
      }).then(res => {
        this.liveDetails = res.data[0]
      })
    },
    onClickRoute() {
      this.$router.push({ path: `/makeAnAppointment/${this.id}` })
    },
    onClickRouteTwo() {
      window.open(this.liveDetails.liveJumpAddress)
    }
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.id = this.$route.params.id
    this.getLiveDetail()
  }
}
</script>

<style lang="less" scoped>
.qualityControl-box {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.center-box {
  padding-bottom: 80px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .poster-box {
    padding-top: 20px;
    position: relative;
    flex: 1;

    img {
      width: 100%;
    }

    .activity-btn-box {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: 300px;
      height: 44px;
      line-height: 44px;
      border-radius: 100px;
      background-color: #8D1D22;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
    }

    .activity-btn-box:hover {
      opacity: 0.8;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Meeting/details.vue